import { ITheme, RecipeTagsType } from "./types";

export const RecipeTags: RecipeTagsType = {
    dessert: "Dessert",
    chicken: "Chicken",
    pork: "Pork",
    fish: "Fish",
    pasta: "Pasta",
    chocolate: "Chocolate"
};

export const Permissions = {
    management: 1,
    blog: 4,
    inbox: 5,
    archives: 5
};

export const slateTheme: ITheme = {
    name: "Slate",
    background: "bg-slate-100 dark:bg-slate-600",
    foreground: "text-slate-500 dark:text-slate-100"
};

const blueTheme: ITheme = {
    name: "Blue",
    background: "bg-blue-100 dark:bg-blue-600",
    foreground: "text-blue-500 dark:text-blue-100"
};

const orangeTheme: ITheme = {
    name: "Orange",
    background: "bg-orange-100 dark:bg-orange-600",
    foreground: "text-orange-500 dark:text-orange-100"
};

const amberTheme: ITheme = {
    name: "Amber",
    background: "bg-amber-100 dark:bg-amber-600",
    foreground: "text-amber-500 dark:text-amber-100"
};

const emeraldTheme: ITheme = {
    name: "Emerald",
    background: "bg-emerald-100 dark:bg-emerald-600",
    foreground: "text-emerald-500 dark:text-emerald-100"
};

const indigoTheme: ITheme = {
    name: "Indigo",
    background: "bg-indigo-100 dark:bg-indigo-600",
    foreground: "text-indigo-500 dark:text-indigo-100"
};

const purpleTheme: ITheme = {
    name: "Purple",
    background: "bg-purple-100 dark:bg-purple-600",
    foreground: "text-purple-500 dark:text-purple-100"
};

const pinkTheme: ITheme = {
    name: "Pink",
    background: "bg-pink-100 dark:bg-pink-600",
    foreground: "text-pink-500 dark:text-pink-100"
};

const redTheme: ITheme = {
    name: "Red",
    background: "bg-red-100 dark:bg-red-600",
    foreground: "text-red-500 dark:text-red-100"
};

export const themes: ITheme[] = [slateTheme, emeraldTheme, blueTheme, indigoTheme, purpleTheme, amberTheme, orangeTheme, pinkTheme, redTheme];
